import { useAppState } from 'AppContextProvider'
import ReinforcementScreenContainer from 'Components/ReinforcementScreen/ReinforcementMain'
import { FC, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { ReinforcementDescriptionHighlight, ReinforcementTitleHighlight } from '../Typography'
import { ReinforcementScreenBackgrounds, ReinforcementScreenContent } from 'types/reinforcementScreenTypes'
import { images } from 'images'

const stepImages: ReinforcementScreenBackgrounds<'loseWeight' | 'otherGoal'> = {
  m: {
    loseWeight: images.yourGoalsInfoLoseWeightMale,
    otherGoal: images.yourGoalsInfoOtherMale
  },
  f: {
    loseWeight: images.yourGoalsInfoLoseWeightFemale,
    otherGoal: images.yourGoalsInfoOtherFemale
  }
}

interface GoalsInfoScreenProps {
  onContinue: (shouldSkipNext?: boolean) => Promise<void>
}

const GoalsInfoScreen: FC<GoalsInfoScreenProps> = ({ onContinue }) => {
  const { appState } = useAppState()

  const screenContent = useMemo((): ReinforcementScreenContent => {
    const { gender = 'f', goals = [] } = appState.selections ?? {}
    const genderKey = (gender === 'o' ? 'f' : gender) as IGender
    const goalType = goals.includes('lose_weight') ? 'loseWeight' : 'otherGoal'
    return {
      localePrefix: `reinforcementScreens.your_goals_info.${genderKey}.${goalType}`,
      backgroundImagePath: stepImages[genderKey]![goalType]
    }
  }, [appState.selections?.gender, appState.selections?.goals])

  return (
    <ReinforcementScreenContainer
      title={
        <Trans
          i18nKey={`${screenContent.localePrefix}.title`}
          components={{ em: <ReinforcementTitleHighlight /> }}
        />
      }
      description={
        <Trans
          i18nKey={`${screenContent.localePrefix}.body`}
          components={{ em: <ReinforcementDescriptionHighlight /> }}
        />
      }
      backgroundImage={screenContent.backgroundImagePath}
      onContinue={onContinue}
    />
  )
}

export default GoalsInfoScreen
